import React, { useState, useEffect } from "react";
import { makeStyles, Typography, Grid, Button } from "@material-ui/core/";
import { withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import TableDialog from "../TableModal";

import { isObjectEmpty } from "../../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import {
  getSelectClassDataFromAPI,
  addSelectModalData,
  clearErrorStatusCode,
  clearErrorMessage,
} from "../../../../reduxSlices/selectClassSlice";
import Backdrop from "../../../Backdrop";
import Aux from "../../../../hoc/Auxilliary";
import MessageIndicator from "../../../SnackBar";
import localizedStrings from "../../../../utils/localize";
import { getApplicantStatus } from "../../../../reduxSlices/applicationSlice";
import { getStudentRegisterAPI } from "../../../../reduxSlices/selectClassSlice";
import { formatDateTime } from "../../../../utils/general";

const useStyle = makeStyles((theme) => ({
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  classFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
}));

const TopItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [displayMessage, setDisplayMessage] = useState("");

  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const classDataFromAPI = useSelector(
    (state) => state.selectClassData.classDataFromAPI,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus,
  );

  const errorMessage = useSelector(
    (state) => state.selectClassData.errorMessage,
  );
  const errorStatusCode = useSelector(
    (state) => state.selectClassData.errorStatusCode,
  );

  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );
  const studentRegisterAPI = useSelector(
    (state) => state.selectClassData.studentRegisterAPI,
  );

  useEffect(() => {
    dispatch(addSelectModalData(classDataFromAPI));
    if (!isObjectEmpty(classDataFromAPI)) {
      dispatch(addSelectModalData(classDataFromAPI));
    }
  }, [classDataFromAPI]);

  useEffect(() => {
    if (window.localStorage.getItem("studentId") != (undefined && null))
      dispatch(getStudentRegisterAPI(window.localStorage.getItem("studentId")));
  }, []);

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };

  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
  }, [dispatch]);

  useEffect(() => {
    if (
      classDataFromAPI.length === 0 &&
      applicantStatus.ses_applicantstatus !== undefined &&
      window.localStorage.getItem("studentId")
    ) {
      dispatch(
        getSelectClassDataFromAPI(
          applicantStatus.ses_applicantstatus._usb_primarydegreeplan_value,
          formatDateTime(),
        ),
      );
    }
    dispatch(clearErrorMessage());
  }, [dispatch, applicantStatus]);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  useEffect(() => {
    if (error.message === "student id is required") {
      setDisplayMessage(localizedStrings.general.studentiderrorMessage);
    } else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else if (error.message === "Error No class Data Found") {
      setDisplayMessage(localizedStrings.general.errornoclassdata);
    } else if (
      error.message ===
      "The student cannot be enrolled because all of the prerequisites for the course have not been met."
    ) {
      setDisplayMessage("");
      let error = {
        isError: false,
        message: "",
        showSnackbar: false,
      };
      setError(error);
    }
  }, [error]);
  useEffect(() => {
    if (
      error.message ===
      "The student cannot be enrolled because all of the prerequisites for the course have not been met."
    ) {
      setTimeout(() => {
        let error = {
          isError: false,
          message: "",
          showSnackbar: false,
        };
        setError(error);
        setDisplayMessage("");
        handleClose();
      }, 30000);
    }
  }, [errorMessage]);

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Grid className={classes.classConatiner}>
        <Typography component="div" className={classes.classFont}>
          {localizedStrings.students.selectClasses.selectClasses}
        </Typography>

        <Typography component="div">
          {studentRegisterAPI?.length > 0 &&
            studentRegisterAPI[0]?.usb_canregister && (
              <Button
                variant="outlined"
                color="primary"
                startIcon={<AddIcon />}
                style={{ textTransform: "capitalize" }}
                onClick={handleClickOpen}
              >
                {localizedStrings.students.selectClasses.addNew}
              </Button>
            )}

          <TableDialog open={open} handleClose={handleClose} />
        </Typography>
      </Grid>
    </Aux>
  );
};

export default withRouter(TopItems);
